angular.module('cvsApp').service('eccrService',['networkService','configManager','eccrModel', function (NS,CM,ECCR) {
   	
	function eccrService (){	
		this.eccr = function(trackingDetail,callBackSuccess){
			//get url 
			var url = CM.getEccrUrl("ECCR", trackingDetail,"ECCR");
			//console.log(url)
			var request = {url:url,
							header:{},
							data:getRequestBody(trackingDetail),
							onSuccess:callBackSuccess
						};
			cvsUtility.commonServiceCode(url,"eccr",ECCR,request,callBackSuccess,NS);
							
		};
		var getRequestBody = function(trackingDetail){
				var timeStamp=cvsUtility.getTimeStamp();
					
				var requestJson = {request:{
								HOST_ID:trackingDetail.HOST_ID,
								COMPONENT_ID:trackingDetail.COMPONENT_ID,
								FAST_INDICATOR:trackingDetail.FAST_INDICATOR
							}};
				
				return cvsUtility.JSONToXml(requestJson);

			};		

					
	}
	
	return new eccrService();	
}]);
